import _defineProperty from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _toArray from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toArray";
import _toConsumableArray from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { isString } from 'vega-util';
import { binToString, isBinning } from '../../bin';
import { binRequiresRange, isTypedFieldDef, normalizeBin, vgField } from '../../channeldef';
import { duplicate, flatten, hash as _hash, keys, unique, vals } from '../../util';
import { binFormatExpression } from '../common';
import { isUnitModel } from '../model';
import { DataFlowNode } from './dataflow';

function rangeFormula(model, fieldDef, channel, config) {
  if (binRequiresRange(fieldDef, channel)) {
    // read format from axis or legend, if there is no format then use config.numberFormat
    var guide = isUnitModel(model) ? model.axis(channel) || model.legend(channel) || {} : {};
    var startField = vgField(fieldDef, {
      expr: 'datum'
    });
    var endField = vgField(fieldDef, {
      expr: 'datum',
      binSuffix: 'end'
    });
    return {
      formulaAs: vgField(fieldDef, {
        binSuffix: 'range',
        forAs: true
      }),
      formula: binFormatExpression(startField, endField, guide.format, config)
    };
  }

  return {};
}

function binKey(bin, field) {
  return "".concat(binToString(bin), "_").concat(field);
}

function getSignalsFromModel(model, key) {
  return {
    signal: model.getName("".concat(key, "_bins")),
    extentSignal: model.getName("".concat(key, "_extent"))
  };
}

function isBinTransform(t) {
  return 'as' in t;
}

function createBinComponent(t, bin, model) {
  var as;

  if (isBinTransform(t)) {
    as = isString(t.as) ? [t.as, "".concat(t.as, "_end")] : [t.as[0], t.as[1]];
  } else {
    as = [vgField(t, {
      forAs: true
    }), vgField(t, {
      binSuffix: 'end',
      forAs: true
    })];
  }

  var normalizedBin = normalizeBin(bin, undefined) || {};
  var key = binKey(normalizedBin, t.field);

  var _getSignalsFromModel = getSignalsFromModel(model, key),
      signal = _getSignalsFromModel.signal,
      extentSignal = _getSignalsFromModel.extentSignal;

  var binComponent = Object.assign({
    bin: normalizedBin,
    field: t.field,
    as: [as]
  }, signal ? {
    signal: signal
  } : {}, extentSignal ? {
    extentSignal: extentSignal
  } : {});
  return {
    key: key,
    binComponent: binComponent
  };
}

export var BinNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(BinNode, _DataFlowNode);

  function BinNode(parent, bins) {
    var _this;

    _classCallCheck(this, BinNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BinNode).call(this, parent));
    _this.bins = bins;
    return _this;
  }

  _createClass(BinNode, [{
    key: "clone",
    value: function clone() {
      return new BinNode(null, duplicate(this.bins));
    }
  }, {
    key: "merge",

    /**
     * Merge bin nodes. This method either integrates the bin config from the other node
     * or if this node already has a bin config, renames the corresponding signal in the model.
     */
    value: function merge(other, renameSignal) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = keys(other.bins)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          if (key in this.bins) {
            renameSignal(other.bins[key].signal, this.bins[key].signal); // Ensure that we don't have duplicate names for signal pairs

            this.bins[key].as = unique([].concat(_toConsumableArray(this.bins[key].as), _toConsumableArray(other.bins[key].as)), _hash);
          } else {
            this.bins[key] = other.bins[key];
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = other.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var child = _step2.value;
          other.removeChild(child);
          child.parent = this;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      other.remove();
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(flatten(flatten(vals(this.bins).map(function (c) {
        return c.as;
      }))));
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set(vals(this.bins).map(function (c) {
        return c.field;
      }));
    }
  }, {
    key: "hash",
    value: function hash() {
      return "Bin ".concat(_hash(this.bins));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      return flatten(vals(this.bins).map(function (bin) {
        var transform = [];

        var _bin$as = _toArray(bin.as),
            binAs = _bin$as[0],
            remainingAs = _bin$as.slice(1);

        var binTrans = Object.assign({
          type: 'bin',
          field: bin.field,
          as: binAs,
          signal: bin.signal
        }, bin.bin);

        if (!bin.bin.extent && bin.extentSignal) {
          transform.push({
            type: 'extent',
            field: bin.field,
            signal: bin.extentSignal
          });
          binTrans.extent = {
            signal: bin.extentSignal
          };
        }

        transform.push(binTrans);
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = remainingAs[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var as = _step3.value;

            for (var i = 0; i < 2; i++) {
              transform.push({
                type: 'formula',
                expr: vgField({
                  field: binAs[i]
                }, {
                  expr: 'datum'
                }),
                as: as[i]
              });
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        if (bin.formula) {
          transform.push({
            type: 'formula',
            expr: bin.formula,
            as: bin.formulaAs
          });
        }

        return transform;
      }));
    }
  }], [{
    key: "makeFromEncoding",
    value: function makeFromEncoding(parent, model) {
      var bins = model.reduceFieldDef(function (binComponentIndex, fieldDef, channel) {
        if (isTypedFieldDef(fieldDef) && isBinning(fieldDef.bin)) {
          var _createBinComponent = createBinComponent(fieldDef, fieldDef.bin, model),
              key = _createBinComponent.key,
              binComponent = _createBinComponent.binComponent;

          binComponentIndex[key] = Object.assign({}, binComponent, binComponentIndex[key], rangeFormula(model, fieldDef, channel, model.config));
        }

        return binComponentIndex;
      }, {});

      if (keys(bins).length === 0) {
        return null;
      }

      return new BinNode(parent, bins);
    }
    /**
     * Creates a bin node from BinTransform.
     * The optional parameter should provide
     */

  }, {
    key: "makeFromTransform",
    value: function makeFromTransform(parent, t, model) {
      var _createBinComponent2 = createBinComponent(t, t.bin, model),
          key = _createBinComponent2.key,
          binComponent = _createBinComponent2.binComponent;

      return new BinNode(parent, _defineProperty({}, key, binComponent));
    }
  }]);

  return BinNode;
}(DataFlowNode);